
import PropTypes from 'prop-types'
import { Divider, Typography } from '@mui/material'
import { SingleSelect } from 'frame/components'

const FilterAttributes = ({ filters, filtered, onFilter }) => {

  const hasList = (list) => list.length > 0
  const { costCentres, effectiveDates, status } = filters

  const onSelectChange = (key) => (value) =>
    onFilter({
      [key]: value,
    })

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </div>
      <Divider />
      <div>
        {hasList(costCentres) && (
          <div
            style={{
              paddingY: 2,
              paddingX: 0
            }}>
            <SingleSelect
              id="costCentre"
              label="Cost Centre"
              options={costCentres}
              value={filtered.costCentre}
              tight
              onChange={onSelectChange('costCentre')} />
          </div>
        )}
        {hasList(effectiveDates) && (
          <div
            style={{
              paddingY: 2,
              paddingX: 0
            }}>
            <SingleSelect
              id="effectiveDates"
              label="Effective Date"
              options={effectiveDates}
              value={filtered.effectiveDate}
              tight
              onChange={onSelectChange('effectiveDate')} />
          </div>
        )}
        {hasList(status) && (
          <div
            style={{
              paddingY: 2,
              paddingX: 0
            }}>
            <SingleSelect
              id="status"
              label="Status"
              options={status}
              value={filtered.status}
              tight
              onChange={onSelectChange('status')} />
          </div>
        )}
      </div>
    </div>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
